import * as scale from "d3-scale";
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Points from "./graph/points";
import Ranges from "./graph/ranges";
import Ticks from "./graph/ticks";
import Tooltip from "./graph/tooltip";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { isNumeric } from "cxa-utils";

class MarkerGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: { display: false, data: { key: "", value: "" } },
      width: this.props.width,
    };
  }

  componentWillMount() {
    this.setState({ width: this.props.width });
  }

  updateSize = () => {
    const parentWidth = this.comp.offsetWidth;

    if (parentWidth < this.props.width) {
      this.setState({ width: parentWidth - 20 });
    } else {
      this.setState({ width: this.props.width });
    }
  };

  showTooltip = e => {
    e.target.setAttribute("fill", "#FFFFFF");

    this.setState({
      tooltip: {
        display: true,
        data: {
          key: e.target.getAttribute("data-key"),
          value: e.target.getAttribute("data-value"),
        },
        pos: {
          x: e.target.getAttribute("cx"),
          y: e.target.getAttribute("cy"),
        },
      },
    });
  };

  hideTooltip = e => {
    e.target.setAttribute("fill", "#7dc7f4");
    this.setState({
      tooltip: { display: false, data: { key: "", value: "" } },
    });
  };

  render() {
    const { marker, ranges, intl } = this.props;
    const { screeningResults: results } = marker;

    const data = [];
    const xValues = marker.xValues.split(",");
    const yValues = marker.yValues.split(",");

    if (xValues.length !== yValues.length) {
      throw new Error(intl.formatMessage(messages.markerxyNotMatchDescription));
    }

    for (let i = 0; i < xValues.length; i++) {
      data.push([new Date(xValues[i]), yValues[i]]);
    }

    const { width } = this.state;
    const { height } = this.props;

    const margin = { top: 5, right: 20, bottom: 30, left: 80 };
    const w = width - (margin.left + margin.right);
    const h = height - (margin.top + margin.bottom);

    const minY = Math.min(...ranges.map(d => d.range[0]));
    const maxY = Math.max(...ranges.map(d => d.range[1]));

    const x = scale
      .scaleLinear()
      .domain([0, data.length + 1])
      .rangeRound([0, w]);

    const y = scale
      .scaleLinear()
      .domain([minY, maxY])
      .range([h, 0]);

    const labelPositions = ranges.map(d => y(d.range[0] + d.span / 2));

    const transform = "translate(" + margin.left + "," + margin.top + ")";
    const labelX = 10;

    const ticks = data.map((d, idx) => idx + 1);
    const pointsData = data.map((d, idx) => [idx + 1, d[1]]);

    const formatKey = x => moment(data[x - 1][0]).format();

    const formatValue = (y, idx) => {
      const resultsArray = [].concat(results);
      if (resultsArray[idx] && resultsArray[idx].labResultValue) {
        if (isNumeric(resultsArray[idx].labResultValue)) {
          return resultsArray[idx].labResultValue;
        }

        return intl.formatMessage({
          id: resultsArray[idx].labResultValue,
          defaultMessage: resultsArray[idx].labResultValue,
        });
      }

      return "";
    };

    return (
      <figure
        className="apl-marker__graph"
        ref={div => {
          this.comp = div;
        }}
      >
        <svg version="1.1" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="xMidYMid meet">
          <g transform={transform}>
            <Ranges ranges={ranges} x={x} y={y} x0={0} x1={data.length + 1} y0={minY} y1={maxY} />

            {/** <Plot
            x={x}
            y={this.props.height}
            data={this.props.data}
          /> **/}
            <Points
              x={x}
              y={y}
              data={pointsData}
              showTooltip={this.showTooltip}
              hideTooltip={this.hideTooltip}
              formatKey={formatKey}
              formatValue={formatValue}
            />
            {/** <line x1={x(prevDay)} y1={y(0)} x2={x(nextDay)} y2={y(minY)} stroke="black" strokeWidth={2} />
             <line x1={x(prevDay)} y1={y(0)} x2={x(prevDay)} y2={y(maxY)} stroke="black" strokeWidth={2} /> **/}
            <Ticks
              transform={`translate(0, ${h})`}
              tickValues={ticks}
              scale={x}
              tickFormat={formatKey}
              orientation="bottom"
              fontSize="0.9em"
            />
            <Tooltip tooltip={this.state.tooltip} />
          </g>
          {ranges.map((d, idx) => (
            <text
              key={`marktext${idx}`}
              x={labelX}
              y={labelPositions[idx]}
              alignmentBaseline="central"
            >
              <tspan fontSize="0.9em">
                {intl.formatMessage({ id: d.label, defaultMessage: d.label })}
              </tspan>
              <tspan x={labelX} fontSize="0.8em" dy="1.4em">
                {intl.formatMessage({
                  id: d.description,
                  defaultMessage: d.description,
                })}
              </tspan>
            </text>
          ))}
        </svg>
      </figure>
    );
  }
}

MarkerGraph.defaultProps = {
  width: 600,
  height: 300,
};

MarkerGraph.propTypes = {
  marker: PropTypes.object.isRequired,
  ranges: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
  intl: intlShape.isRequired,
};

export default injectIntl(MarkerGraph);



// WEBPACK FOOTER //
// ./components/employee/wellness/markerGraph.jsx